import React from 'react'

function Title({ children, ...rest }) {
    return (
        <div className={`text-[30px] md:text-[46px] text-white font-bold leading-none  ${rest.className}`}>
            {children}
        </div>
    )
}

export default Title